import { Modal } from 'ant-design-vue';

let appContext;

export const setModalAppContext = context => {
  appContext = context;
};

const withAppContext = config => ({
  ...(config || {}),
  appContext,
});

export const modalService = {
  confirm: config => Modal.confirm(withAppContext(config)),
  info: config => Modal.info(withAppContext(config)),
  success: config => Modal.success(withAppContext(config)),
  error: config => Modal.error(withAppContext(config)),
  warning: config => Modal.warning(withAppContext(config)),
  warn: config => Modal.warn(withAppContext(config)),
  destroyAll: () => Modal.destroyAll(),
};
